const byteToMegabyte = (sizeInBytes) => {
    return (sizeInBytes / (1024*1024)).toFixed(2);
};

const distinctElementsFromList = (list = [], distinctKey = 'id', distinctResult, areaModel = null, selectedDeviceGroup = null) => {
    const result = [];
    const map = new Map();
    if(list) {
        for(const item of list) {
            if(!map.has(item[distinctKey])) {
                map.set(item[distinctKey], true);

                if(distinctResult && areaModel) {
                    result.push({
                        count: list.filter((x) => ((x[distinctKey] === item[distinctKey]) && (x.label.includes(areaModel.inclx))))?.length,
                        item: item[distinctResult]
                    })
                }
                else if(distinctResult && selectedDeviceGroup) {
                    let countList = list.filter((x) => ((x[distinctKey] === item[distinctKey] && (x.deviceGroupIds.includes(selectedDeviceGroup)))))?.length;
                    result.push({
                        count: countList,
                        item: item[distinctResult]
                    })
                }
                else if (distinctResult) {
                    result.push({
                        count: list.filter((x) => x[distinctKey] === item[distinctKey])?.length,
                        item: item[distinctResult]
                    })
                }
                else {
                    result.push({
                        count: list.length,
                        item: item
                    });
                }
            }
        }
    }
    return result;
}

const removeExtension =(filename) => {
    const lastDotPosition = filename.lastIndexOf(".");
    if (lastDotPosition === -1) return filename;
    else return filename.substr(0, lastDotPosition);
}

export const formatterHelper = {
    byteToMegabyte,
    distinctElementsFromList,
    removeExtension
};
